export default "__VITE_ASSET__D_565t0J__"